import axios from "axios";
import { Article } from "./updateArticle";

export const getArticles = async (token?: string): Promise<Article[]> => {
    try {
        const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

        const response = await axios.get(
            "https://portfoliom-backend.vercel.app/articles",
            { headers }
        );

        // API { success: true, data: [...] } formatında dönüyorsa
        if (response.data && response.data.data) {
            return response.data.data;
        }

        // Direkt dizi dönüyorsa
        return response.data || [];
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Axios hatası:", error.response?.data || error.message);
        } else {
            console.error("Bilinmeyen hata:", error);
        }
        throw new Error("Makaleler getirilirken hata oluştu");
    }
};
